import { orderSectorsLikeSdm } from "../constants/sdmSectors";

/** Normalize sector dropdown options to SDM category order. */
export function buildSdmSectorOptions(apiSectors) {
  return orderSectorsLikeSdm(Array.isArray(apiSectors) ? apiSectors : []);
}
